import { Layout, Menu, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNavItems } from './navUtils';

const { Sider } = Layout;

export default function Sidebar({ routes, collapsed, onCollapse }) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const navGroups = useNavItems(routes);

  const items = Object.entries(navGroups).flatMap(([group, groupItems]) => [
    { type: 'group', label: t(`groups.${group}`), children: groupItems.map((item) => ({
      key: item.key,
      icon: item.icon,
      label: item.disabled ? item.label : item.label,
      disabled: item.disabled,
    })) },
  ]);

  const navPaths = routes
    .filter((r) => r.nav || r.path.includes(':'))
    .map((r) => r.path);

  const selectedKey =
    navPaths.find((path) => location.pathname === path) ||
    navPaths
      .filter((path) => {
        if (path === '/') return false;
        const base = path.split('/:')[0];
        return location.pathname.startsWith(`${base}/`);
      })
      .sort((a, b) => b.length - a.length)[0] ||
    location.pathname;

  return (
    <Sider
      className="admin-sidebar"
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      breakpoint="lg"
      width={240}
    >
      <div className="sidebar-brand">
        <Typography.Title level={5} className="sidebar-brand__title">
          {collapsed ? 'M' : t('app.name')}
        </Typography.Title>
      </div>
      <Menu
        className="admin-sidebar__menu"
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        items={items}
        onClick={({ key }) => navigate(key)}
      />
    </Sider>
  );
}
